module.exports = "/images/veil-15.jpg";